import { getBreadCrumbList } from '../utils/get-breadcrumb-list'
import { useUserRQInfo } from '@/components/Common/user-provider/user-provider'
import BreadCrumb from '@/stories/components/Common/BreadCrumbs'
import BackNavigation from '@/stories/components/Common/BackNavigation'
import { handleNavigationBack } from '@/root/utils/webview/navigation-back'

type TUSL2BreadcrumbsProps = {
  companyName?: string
  ticker?: string
  slug?: string
}

export default function USL2Breadcrumbs(props: TUSL2BreadcrumbsProps) {
  const { companyName, ticker, slug } = props
  const { isAuthenticated } = useUserRQInfo()

  if (!companyName) return null

  return (
    <div className="flex items-center justify-start">
      <div className="scale-75 transform">
        <BackNavigation onClick={handleNavigationBack} />
      </div>

      <BreadCrumb
        structuredSchemaInHTML
        breadCrumbList={getBreadCrumbList(
          companyName,
          ticker ?? '',
          isAuthenticated,
          slug ?? '',
        )}
        labelClassName="line-clamp-1"
      />
    </div>
  )
}
